/**
 * Sans configuration exploitable, l'application ne démarre pas — et un écran blanc muet
 * enverrait chercher la panne dans l'application plutôt que dans son déploiement. Le motif
 * s'affiche donc à la place de l'application.
 */
export function reportStartupFailure(
  failure: unknown,
  root: Element | null = document.querySelector('app-root'),
): void {
  console.error(failure);
  if (!root) {
    return;
  }

  const message = document.createElement('p');
  message.setAttribute('role', 'alert');
  message.style.cssText = 'margin: 2rem; font-family: sans-serif; white-space: pre-wrap;';
  // textContent, jamais innerHTML : le message peut reprendre le contenu d'un fichier servi.
  message.textContent = `L'application n'a pas pu démarrer : ${
    failure instanceof Error ? failure.message : String(failure)
  }`;
  root.replaceChildren(message);
}
